var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.54,10.21H3a1,1,0,0,0,0,2.08h7.5a1,1,0,1,0,0-2.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,5.62H17.21a1,1,0,0,0,0-2.08H3A1,1,0,1,0,3,5.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87,16.88H3A1,1,0,0,0,3,19H8.87a1,1,0,1,0,0-2.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,15a1.19,1.19,0,0,0-.72-.3,1,1,0,0,0-.73.3L18.32,17V9.73a1,1,0,0,0-2,0v7.11l-1.65-1.79a1,1,0,0,0-1.51,1.38l3.41,3.7h0a1,1,0,0,0,.73.33h0a1,1,0,0,0,.72-.3l3.7-3.7a1,1,0,0,0,0-1.44Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.afffafbb00e38ce3bd7129f83995fbf2.svg";
export { ForwardRef as ReactComponent };